import { NaviTableColumnDef } from '@cp/src/components/NaviTable/interfaces';
import RetriggerAllocationsButton from './RetriggerAllocationsButton';
import { formatAmount } from '@cp/src/utils/commonUtils';

export const getCumulativeAllocationDetailsColumnDefs = (
  handleRetriggerClick: () => void
): NaviTableColumnDef<any, any>[] => [
  {
    accessorKey: 'numberOfAgents',
    header: 'Number of agents',
    size: 160,
    tooltip: false
  },
  {
    accessorKey: 'emiToBeAllocated',
    header: 'EMI to be allocated',
    size: 160,
    cell: ({ row }) => {
      return formatAmount(row.original.emiToBeAllocated, false);
    }
  },
  {
    accessorKey: 'totalAgentCapacity',
    header: 'Total case Load',
    size: 160,
    cell: ({ row }) => {
      return formatAmount(row.original.totalAgentCapacity, false);
    }
  },
  {
    accessorKey: 'emiLeftForAllocation',
    header: 'EMI left for allocation',
    size: 240,
    cell: ({ row }) => {
      return formatAmount(row.original.emiLeftForAllocation, false);
    }
  },
  {
    accessorKey: 'action',
    header: 'Action',
    size: 240,
    cell: () => {
      return <RetriggerAllocationsButton onClick={handleRetriggerClick} />;
    }
  }
];
